import * as React from "react";
const SvgFiRrArrowComparison = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrow-comparison_svg__a)">
      <path
        fill="#062147"
        d="M23.707 10.293a1 1 0 0 1 0 1.414l-6.327 6.327a3.37 3.37 0 0 1-4.76 0l-1.654-1.654a1.37 1.37 0 0 0-1.932 0L3.414 22H6a1 1 0 0 1 0 2H2c-1.103 0-2-.897-2-2v-4a1 1 0 0 1 2 0v2.586l5.62-5.62c1.271-1.271 3.488-1.271 4.76 0l1.654 1.654c.516.516 1.416.516 1.932 0l6.327-6.327a1 1 0 0 1 1.414 0M22 0h-4a1 1 0 1 0 0 2h2.586l-5.62 5.62a1.37 1.37 0 0 1-1.932 0L11.38 5.966a3.37 3.37 0 0 0-4.76 0L.293 12.293a.999.999 0 1 0 1.414 1.414L8.034 7.38c.516-.516 1.416-.516 1.932 0l1.654 1.654c1.271 1.271 3.488 1.271 4.76 0L22 3.414V6a1 1 0 1 0 2 0V2c0-1.103-.897-2-2-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrow-comparison_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowComparison;
